export default {
	data() {
		return {
			moduleName: 'deviceConfigs',
			detailPageRouteName: 'deviceConfigDetail',
			entity: {
				id_operator: null,
				id_device_type: null,
				name: null,
				feature_settings: null,
				device: {},
				player: {},
				platform: {},
				player_config: null,
				player_config_merge: false
			},
			updateFields: [
				'name',
				'id_device_type',
				'feature_settings',
				'device',
				'player',
				'platform',
				'id_operator',
				'player_config',
				'player_config_merge'
			],
		}
	},
	methods: {
		filterFormParams(params) {
			let allowed = {}
			this._.forOwn(params, function (value, key) {
				if (this.updateFields.includes(key)) {
					allowed[key] = value
				}
			}.bind(this))
			return allowed
		},
		resetFields() {
			/*
			this.$refs['protocolformref'].validateProtocolFormRequiredFields()
			this.$refs['protocolformref'].$refs['nameref'].setTouched(false) */
		},
		processErrorMessage(error) {
			let errorMessage = null;
			// this.$refs['protocolformref'].validateProtocolFormRequiredFields()

			this._.forEach(error['validation_errors'], function (message) {
				errorMessage = message;
			}.bind(this))

			return error['error_message'] = errorMessage || error['error_message'];
		},
		_processDetailErrorMessage(error) {
			let deleteError = null
			this._.forEach(error['validation_errors'], function (errorMessage) {
				deleteError = errorMessage;
			}.bind(this))

			if (deleteError) {
				error['error_message'] = deleteError
			}

			return error['error_message']
		},
		openRoute(routerName) {
			this.$router.push({
				name: routerName
			})
		},
		getDependency() {
			this.setLoadingMessage();

			return this.entityService.getDependency().then((response) => {
				this.deviceTypes = _.sortBy(response.device_types, [(x) => x.name.toLowerCase()]);
				this.availableValues = response.available_values;

				this.emptyMessage();
			});
		},
	},
	computed: {
		operatorIdComputed: {
			get() {
				return this.entity.id_operator
			},
			set(newValue) {
				this.entity.id_operator = newValue
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/deviceConfigs/mixins/deviceConfigs.js